import { render, staticRenderFns } from "./ClassicCase.vue?vue&type=template&id=4b045fe8&scoped=true"
import script from "./ClassicCase.vue?vue&type=script&lang=js"
export * from "./ClassicCase.vue?vue&type=script&lang=js"
import style0 from "./ClassicCase.vue?vue&type=style&index=0&id=4b045fe8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b045fe8",
  null
  
)

export default component.exports